import { render } from "./TestIts.vue?vue&type=template&id=cc217d82"
import script from "./TestIts.vue?vue&type=script&lang=js"
export * from "./TestIts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__